module.exports = __webpack_public_path__ + "static/media/facebook.0e2efee5.svg";